export default __webpack_public_path__ + "static/media/google-play.dc1a5410.svg";